module.exports = __webpack_public_path__ + "78dda76bc3f268cafa4f28570d3bba0b.svg";